<template>
<!-- eslint-disable max-len -->
  <div class="container" v-if="noDemo">
    <div class="row my-4 my-md-5">
      <div class="col-sm-12 d-flex align-items-center justify-content-center">
        <img :src="resolveAssetPath('GameRoomTitle.png', 'ui/customer')" class="w-50" />
      </div>
    </div>
    <div class="row no-gutters">
      <div class="col-sm-12 list-form">
        <h2>You are not assigned any gamulations! Please contact support to resolve this issue.</h2>
      </div>
      <div class="col-sm-12 list-form" v-if="false">
        <h2>
          My Games
          <span class="btn btn-primary btn-small p-1 float-right" @click="loadPageData">Refresh</span>
        </h2>
        <template v-if="startedGroups.length">
          <hr>
          <h3>In Progress</h3>
          <ul>
            <li v-for="group in startedGroups" :key="group._id">
              <router-link :to="`/groups/${group._id}`">
                <p>{{ group.title }} ({{ (games[group.game] || {}).title || 'Missing Gamulation' }}{{ group.demo ? ': ACTIVE' : ''}})</p>
              </router-link>
            </li>
          </ul>
        </template>
        <template v-if="completedGroups.length">
          <hr>
          <h3>Completed</h3>
          <ul>
            <li v-for="group in completedGroups" :key="group._id" class="completed">
              <p>{{ group.title }} ({{ (games[group.game] || {}).title || 'Missing Gamulation' }}{{ group.demo ? ': ACTIVE' : ''}})</p>
            </li>
          </ul>
        </template>
        <div v-if="!startedGroups.length && !completedGroups.length">
          <h3>You are not part of any groups yet.</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      groups: [],
      games: {},
      noDemo: false
    };
  },
  computed: {
    startedGroups() {
      return this.groups.filter(({ demo, status }) => !demo && status === 'started');
    },
    completedGroups() {
      return this.groups.filter(({ demo, status }) => !demo && status === 'complete');
    }
  },
  async created() {
    // this loads all running groups for the user, which is expensive, but we don't actually use the results at the moment.
    // so commenting this out until that changes.
    // await this.loadPageData();
    this.$router.push('/demo');
    // this.noDemo = true;
  },
  methods: {
    ...mapActions([
      'getMyGroups',
      'flashDanger'
    ]),
    async loadPageData() {
      try {
        const { groups, games } = await this.getMyGroups();
        this.groups = groups;
        this.games = games.reduce((acc, game) => {
          acc[game._id] = game;
          return acc;
        }, {});
      } catch (_) {
        const message = 'Could not get your groups';
        this.flashDanger({ message });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.list-form {
  padding: 20px;
  background-color: white;
}
.list-form ul {
  list-style: none;
  padding-left: 0;
}
.list-form li {
  color: black;
  border: 2px solid black;
  padding: 5px;
  margin-bottom: 5px;
}
.list-form li a {
  color: black;
}
.list-form li:hover, .list-form li.completed {
  border: 2px solid var(--primaryColor);
  background-color: var(--primaryColor);
  color: white;
}
.list-form li:hover a, .list-form li.completed p {
  color: white;
  text-decoration: none;
}
.list-form li p {
  margin: 0;
}
.list-form li p:first-of-type {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/home/MyGroups.vue